/**
 * Whether the message signature toggle should be shown in the reply composer.
 * When false, users should not be prompted to configure a missing signature.
 */
export function shouldShowMessageSignatureButton() {
  // Chati fork: signature toggle disabled in reply composer
  return false;
}
